/* ═══════════════════════════════════════════
   COFFEE DU NORD — Theme JavaScript
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Animated Counters ──
  const counters = document.querySelectorAll('[data-cdn-counter]');
  if (counters.length) {
    const animateCounter = (el) => {
      const target = parseInt(el.dataset.cdnCounter, 10);
      const duration = 2200;
      const step = target / (duration / 16);
      let current = 0;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        el.textContent = Math.floor(current).toLocaleString();
      }, 16);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.dataset.cdnAnimated) {
          entry.target.dataset.cdnAnimated = 'true';
          animateCounter(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(counter => observer.observe(counter));
  }

  // ── Mobile Nav Toggle ──
  const hamburger = document.querySelector('.cdn-nav__hamburger');
  const mobileNav = document.querySelector('.cdn-nav__mobile');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('is-open');
      const isOpen = mobileNav.classList.contains('is-open');
      hamburger.setAttribute('aria-expanded', isOpen);
    });
  }

  // ── Scroll fade-in for sections ──
  const fadeEls = document.querySelectorAll('[data-cdn-fade]');
  if (fadeEls.length) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cdn-fade--visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(el => fadeObserver.observe(el));

    // Inject fade CSS
    const style = document.createElement('style');
    style.textContent = `
      [data-cdn-fade] { opacity: 0; transform: translateY(20px); transition: opacity 0.7s ease, transform 0.7s ease; }
      [data-cdn-fade].cdn-fade--visible { opacity: 1; transform: translateY(0); }
    `;
    document.head.appendChild(style);
  }

});
